module.exports = __webpack_public_path__ + "img/config-account-icon.4c2a38af.svg";